<template>
  <div>

    <page-heading-info
    title="Jefferson County Real Estate Search"
    phone="(740) 283-8518"
    >
      <div class="row">
        <div class="col-6 header-image">
          <img src="/static/images/auditor/ej_web_01.png" style="border: 2px solid #2277b5;" />
        </div>
        <div class="col-6 header-image">
          <img src="/static/images/auditor/EJ_Seal_02_blue_150.png" />
        </div>
      </div>
    </page-heading-info>

    <!-- search form -->
    <div class="row">
    
      <div class="col-md-6 mt-3">

        <div class="row mt-3">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Owner Name</label>
            <input type="email" class="form-control" v-model="search.owner_name_1" @keyup.enter="getReal()">
          </div>

          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Owner Address</label>
            <input type="email" class="form-control" v-model="search.owner_address_1" @keyup.enter="getReal()">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Location Address</label>
            <input type="email" class="form-control" v-model="search.location_address" @keyup.enter="getReal()">
          </div>

          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Parcel Number</label>
            <input type="email" class="form-control" v-model="search.parcel_number" @keyup.enter="getReal()">
          </div>
        </div>

        <div class="form-group">
          <label for="exampleInputEmail1">District</label>
          <select class="form-control" v-model="district_id">
            <option v-for="d in selectDistrict" :value="d.value">{{d.label}}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="exampleInputEmail1">Parcel Class</label>
          <select class="form-control" v-model="parcelClass">
            <option v-for="c in selectClass" :value="c.value">{{c.label}}</option>
          </select>
        </div>

      </div>

      <div class="col-md-6 mt-3">

        <div class="mt-3">Acres</div>
        <div class="input-group mt-2">
          <div class="input-group-prepend">
            <span class="input-group-text">From</span>
          </div>
          <input type="text" class="form-control" v-model="search.begin_acre" @keyup.enter="getReal()">
          
          <div class="input-group-prepend ml-3">
            <span class="input-group-text">To</span>
          </div>
          <input type="text" class="form-control" v-model="search.end_acre" @keyup.enter="getReal()">
        </div>

        <div class="mt-3">Land Value</div>
        <div class="input-group mt-2">
          <div class="input-group-prepend">
            <span class="input-group-text">From</span>
          </div>
          <input type="text" class="form-control" v-model="search.begin_land_value" @keyup.enter="getReal()">
          
          <div class="input-group-prepend ml-3">
            <span class="input-group-text">To</span>
          </div>
          <input type="text" class="form-control" v-model="search.end_land_value" @keyup.enter="getReal()">
        </div>

        <div class="mt-3">Improve Value</div>
        <div class="input-group mt-2">
          <div class="input-group-prepend">
            <span class="input-group-text">From</span>
          </div>
          <input type="text" class="form-control" v-model="search.begin_improve_value" @keyup.enter="getReal()">
          
          <div class="input-group-prepend ml-3">
            <span class="input-group-text">To</span>
          </div>
          <input type="text" class="form-control" v-model="search.end_improve_value" @keyup.enter="getReal()">
        </div>

        <div class="mt-3">Agricultural Value</div>
        <div class="input-group mt-2">
          <div class="input-group-prepend">
            <span class="input-group-text">From</span>
          </div>
          <input type="text" class="form-control" v-model="search.begin_agriculture_value" @keyup.enter="getReal()">
          
          <div class="input-group-prepend ml-3">
            <span class="input-group-text">To</span>
          </div>
          <input type="text" class="form-control" v-model="search.end_agriculture_value" @keyup.enter="getReal()">
        </div>

      </div>

      <div class="col-12 mt-4">
        <div class="row">
          <div class="col-md-6">
            <button class="btn btn-primary" @click="getReal()">
              SEARCH
            </button>
          </div>
        </div>
      </div>

    </div> <!-- end of main row form -->

    <!-- results display -->

    <div v-if="zeroResults == true" class="mt-5 font-size-15">
      No results  
    </div>

    <!-- search results for small screens -->
    <div class="row d-md-none mt-4" v-if="resultsSet == true">
      <div class="col-12 mb-3 clickable" v-for="(real,index) in realData" @click="handleClick(real.parcel_number)">
        <div v-if="index % 2 == 0" class="evenrow p-3">
          <div>Parcel Number: {{real.parcel_number}}</div>
          <div>Parcel Owner: {{real.owner_name_1}}</div>
          <div>Acres: {{real.acres}}</div>
          <div>Land Value: {{formatDollars(real.land_value)}}</div>
          <div>Improve Value: {{formatDollars(real.improve_value)}}</div>
          <div>Agricultural Value: {{formatDollars(real.agr_land_value)}}</div>
          <div>Owner Address: {{formatAddress(real)}}</div>
          <div>Parcel Address: {{real.location_address}}</div>
          <div>Class: {{formatClass(real.class)}}</div>
        </div>
        <div v-else class="p-3">
          <div>Parcel Number: {{real.parcel_number}}</div>
          <div>Parcel Owner: {{real.owner_name_1}}</div>
          <div>Acres: {{real.acres}}</div>
          <div>Land Value: {{formatDollars(real.land_value)}}</div>
          <div>Improve Value: {{formatDollars(real.improve_value)}}</div>
          <div>Agricultural Value: {{formatDollars(real.agr_land_value)}}</div>
          <div>Owner Address: {{formatAddress(real)}}</div>
          <div>Parcel Address: {{real.location_address}}</div>
          <div>Class: {{formatClass(real.class)}}</div>
        </div>
      </div>
    </div>

    <!-- search results for large screens -->
    <div id="search-results" class="row justify-start align-items-center mt-5 ml-1 mb-3 d-none d-md-block" v-if="resultsSet == true">

      <table class="table">
        <thead class="rec-table-header">
          <tr>
            <!-- <th scope="col">Id</th> -->
            <th scope="col">Parcel Number</th>
            <th scope="col">Parcel Owner</th>
            <th scope="col">Acres</th>
            <th scope="col">Land Value</th>
            <th scope="col">Improve Value</th>
            <th scope="col">Agr Value</th>
            <th scope="col">Owner Address</th>
            <th scope="col">Parcel Address</th>
            <th scope="col">Class</th>
          </tr>
        </thead>
        <tbody>

          <tr v-for="(real,index) in realData" :class="evenRows(index)" class="clickable" @click="handleClick(real.parcel_number)">
            <td>{{real.parcel_number}}</td>
            <td>{{real.owner_name_1}}</td>
            <td>{{real.acres}}</td>
            <td>{{formatDollars(real.land_value)}}</td>
            <td>{{formatDollars(real.improve_value)}}</td>
            <td>{{formatDollars(real.agr_land_value)}}</td>
            <td>{{formatAddress(real)}}</td>
            <td>{{real.location_address}}</td>
            <td>{{formatClass(real.class)}}</td>
          </tr>

        </tbody>
      </table>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import PageHeadingInfo from '@/components/layout/PageHeadingInfo'
import TextBoxTitle from '@/components/layout/TextBoxTitle'

export default {
  components: {
    PageHeadingInfo,
    TextBoxTitle
  },
  data () {
    return {
      search: {
        owner_name_1:"",
        owner_address_1:"",
        location_address:"",
        parcel_number:"",
        begin_acre:"",
        end_acre:"",
        begin_land_value:"",
        end_land_value:"",
        begin_improve_value:"",
        end_improve_value:"",
        begin_agriculture_value:"",
        end_agriculture_value:""
      },
      searchSend : {
        owner_name_1:"",
        owner_address_1:"",
        location_address:"",
        parcel_number:"",
        class: "",
        district_id: "",
        begin_acre:"",
        end_acre:"",
        begin_land_value:"",
        end_land_value:"",
        begin_improve_value:"",
        end_improve_value:"",
        begin_agriculture_value:"",
        end_agriculture_value:""
      },
      realData: [],
      selectClass: [],
      parcelClass: "0",
      selectDistrict: [],
      district_id: "0",
      resultsSet: false,
      zeroResults: false
    }
  },
  mounted: function() {
    this.getDistricts()
    this.generateClasses()
  },
  methods: {
    getDistricts: function() {
      let local = this

      //ajax query
      axios({
          method: 'get',
          url: this.$helpers.api() + '/real/districts',
          headers: {'X-Requested-With': 'XMLHttpRequest'}
        })
        .then(function (res) {
          local.setDistricts(res.data)
        })
        .catch(function (error) {
          console.log("fetching districts error: ", error)
        });
    },

    setDistricts: function(data) {
      //set default
      let newDistrict = {}
      newDistrict.label = "All"
      newDistrict.value = "0"
      this.selectDistrict.push(newDistrict)

      //set from db
      for (var i=0; i<data.length; i++) {
        let newDistrict = {}
        newDistrict.label = data[i]["dropdown_name"]
        newDistrict.value = data[i]["district"]
        this.selectDistrict.push(newDistrict)
      }
    },

    generateClasses: function() {
      this.createClass("All", "0")
      this.createClass("Abatement", "700")
      this.createClass("Agricultural", "100")
      this.createClass("Commercial", "400")
      this.createClass("Exempt", "600")
      this.createClass("Industrial", "300")
      this.createClass("Mineral", "200")
      this.createClass("Residential", "500")
      this.createClass("Utilities", "800")
    },

    createClass: function(label,value) {
      let newClass = {}
      newClass.label = label
      newClass.value = value
      this.selectClass.push(newClass)
    },

    getReal: function() {
      //set loading animation
      this.resultsSet = false
      this.loaderAnim = true

      //get reference to component level this
      var local = this

      //format data
      this.formatSearchData()

      //get search results location to scroll to
      let searchDiv = this.$el.querySelector('#search-results')

      //get url parameters
      let params = this.getUrlParams()

      //set api url parameters
      let apiParams = ""

      //check for optional result limits via url
      if (Object.keys(params).length > 0) {
        apiParams = '/' + params.start +
                    '/' + params.end
      }

      //ajax query
      axios({
          method: 'post',
          url: this.$helpers.api() + '/real/search' + apiParams,
          data: this.searchSend,
          headers: {'X-Requested-With': 'XMLHttpRequest'}
        })
        .then(function (response) {
          local.realData = response.data
          local.resultsSet = true
          local.loaderAnim = false
          local.resetSearchSend()
          //local.$router.push({ hash: '#search-results' })
        })
        .catch(function (error) {
          //if error is because of no search params, show warning
          if (error.response.data.trim() === 'parameter') {
              //local.formModal()
          }

          console.log("fetching real estate error: ", error.response.data)
        });
    },

    formatSearchData: function() {
      //this function takes the values from land values as whole dollar amounts
      //and converts them to cents to query correctly
      this.searchSend.owner_name_1 = this.search.owner_name_1.toLowerCase()
      this.searchSend.owner_address_1 = this.search.owner_address_1.toLowerCase()
      this.searchSend.location_address = this.search.location_address.toLowerCase()
      this.searchSend.parcel_number = this.addParcelDashes(this.search.parcel_number)
      this.searchSend.class = this.parcelClass;
      this.searchSend.district_id = this.district_id.toString();
      this.searchSend.begin_acre = parseInt(this.search.begin_acre)
      this.searchSend.end_acre = parseInt(this.search.end_acre)
      this.searchSend.begin_land_value = this.$helpers.encodeCents(this.search.begin_land_value)
      this.searchSend.end_land_value = this.$helpers.encodeCents(this.search.end_land_value)
      this.searchSend.begin_improve_value = this.$helpers.encodeCents(this.search.begin_improve_value)
      this.searchSend.end_improve_value = this.$helpers.encodeCents(this.search.end_improve_value)
      this.searchSend.begin_agriculture_value = this.$helpers.encodeCents(this.search.begin_agriculture_value)
      this.searchSend.end_agriculture_value = this.$helpers.encodeCents(this.search.end_agriculture_value)
    },

    formatDollars: function(amt) {
      let dollars = this.$helpers.parseCents(amt)
      let encoded = this.$helpers.encodeCurrency(dollars).toLocaleString()
      return encoded
    },

    formatAddress: function(res) {
      return res.owner_address_1 + " " + res.owner_address_2
    },

    formatClass: function(classNum) {
      //this function take a number and returns the corresponding text
      if (classNum < 200) {
        return "Agricultural"
      }

      if (classNum >= 200 && classNum < 300) {
        return "Mineral"
      }

      if (classNum >= 300 && classNum < 400) {
        return "Industrial"
      }

      if (classNum >= 400 && classNum < 500) {
        return "Commercial"
      }

      if (classNum >= 500 && classNum < 600) {
        return "Residential"
      }

      if (classNum >= 600 && classNum < 700) {
        return "Exempt"
      }

      if (classNum >= 700 && classNum < 800) {
        return "Abatement"
      }

      if (classNum >= 800) {
        return "Utilities"
      }
    },

    getUrlParams: function() {
      let params = {}
      let start = this.$route.params.start
      let end = this.$route.params.end

      if (start != undefined && start != "") {
        if (end != undefined && end != "") {
          params.start = start
          params.end = end
        }
      }
      return params
    },

    addParcelDashes: function(input) {
      //formats an input into format wanted by the search api
      let arr = input.split("")
      let noDashes = new Array()
      let dashes = new Array()
      
      //make character array without dashes
      for (var i=0; i<arr.length; i++) {
        if (arr[i] != "-") {
            noDashes.push(arr[i])
        } 
      }

      //pad 7 character parcel numbers with 3 zeros
			/*
      if (noDashes.length == 7) {
        noDashes.push("0")
        noDashes.push("0")
        noDashes.push("0")
      }
			*/

      //create dashed array, and join into a search string
      for (var i=0; i<noDashes.length; i++) {
        if (i === 2 || i === 7) {
            dashes.push("-")
        }

        dashes.push(noDashes[i])
      }

      let pNum = dashes.join("")

      return pNum
    },

    formModal: function() {
      this.$refs.basicModal.open()
    },

    handleClick: function(parcelNumber) {
      let date = new Date()
      let year = date.getFullYear() - 1 //get last year's data
      let url = "http://www1.jeffersoncountyoh.com/taxdata/JefPub3.dbw?Owner=%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20" + parcelNumber + "%20%20%20%20%20%20%20%20&SelectYear=" + year
      window.open(url, '_blank');
    },

    evenRows: function(index) {
      if (index % 2 === 0) {
        return "evenrow"
      }

      return "oddrow"
    },

    resetSearchSend: function() {
        this.searchSend = {
        owner_name_1:"",
        owner_address_1:"",
        location_address:"",
        parcel_number:"",
        class:"",
        district_id:"",
        begin_acre:"",
        end_acre:"",
        begin_land_value:"",
        end_land_value:"",
        begin_improve_value:"",
        end_improve_value:"",
        begin_agriculture_value:"",
        end_agriculture_value:""
      }
    }
  }
}
</script>

<style scoped>

  .clickable {
    cursor: pointer;
  }

  .evenrow {
    background-color: #ccc;
  }

  .oddrow {
    background-color: #fff;
  }

  .header-image img {
    flex: none;
    width: 100%;
    max-width: 150px;
  }

</style>
